import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=50ec7106&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"
import style0 from "./Detail.vue?vue&type=style&index=0&id=50ec7106&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ec7106",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50ec7106')) {
      api.createRecord('50ec7106', component.options)
    } else {
      api.reload('50ec7106', component.options)
    }
    module.hot.accept("./Detail.vue?vue&type=template&id=50ec7106&scoped=true", function () {
      api.rerender('50ec7106', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/purchaseService/components/Detail.vue"
export default component.exports